// Zone utilities and types for octograph control

export const OCTOGRAPH_ZONES = [
  { id: "vibration", label: "Vibration", abbrev: "V", color: "#22c55e", angle: 0, parameter: "vibration" },
  { id: "rotation", label: "Rotation", abbrev: "R", color: "#f97316", angle: 45, parameter: "rotation" },
  { id: "pitch", label: "Pitch", abbrev: "P", color: "#ec4899", angle: 90, parameter: "rotation" },
  { id: "suction", label: "Suction/Valve", abbrev: "Su/V", color: "#3b82f6", angle: 135, parameter: "air" },
  { id: "squeeze", label: "Squeeze", abbrev: "Sq", color: "#ef4444", angle: 180, parameter: "squeeze" },
  { id: "roll", label: "Roll", abbrev: "RL", color: "#06b6d4", angle: 225, parameter: "rotation" },
  { id: "twist", label: "Twist", abbrev: "T", color: "#eab308", angle: 270, parameter: "rotation" },
  { id: "inflation", label: "Inflation", abbrev: "IN", color: "#f472b6", angle: 315, parameter: "air" },
] as const

export type ZoneState = "off" | "zone" | "global"
